import { SliceSeries } from '@/modules/core/legacy/charts/models/SliceSeries';

/**
 * @class FunnelSeries
 * @extends SliceSeries
 */
export class FunnelSeries extends SliceSeries {}
